import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { Redirect } from 'react-router-dom';
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import Loader from "react-loader-spinner";
import Cookies from "universal-cookie";
import { debounce } from 'lodash';
import Header from "../Components/Header";
import { MetodePembayaran } from "../Components/FormComponent";
import * as Constant from "../Constant"
import "./pembayaran.css";
import { css } from '@emotion/core';
import ClipLoader from "react-spinners/ClipLoader";

const cookies = new Cookies();
const MIDTRANS_CLIENT_KEY = 'SB-Mid-client-lZzj2SWMQuGleE8k'
const MINIMUM_PAYMENT_AMOUNT = 1;



const LoadingIndicator = () => {
  const { promiseInProgress } = usePromiseTracker();
  return promiseInProgress && (
    <div className="loader-container">
      <Loader type="ThreeDots" color="white" height={40} width={40} />
    </div>
  );
};

const Pendaftaran = () => {
  const [paymentData, setPaymentData] = useState({
    id: null, santri_name: "", nominal: 0, tahun_ajaran: "", type: "", sudah_dibayar: "",
  });
  const [userData, setUserData] = useState({
    user_id: "", full_name: "", phone_number: "", email: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [paymentState, setPaymentState] = useState({
    selected_method: null, selected_vendor: null, no_rekening: "", btn_pay: "Bayar Sekarang", nominal_pembayaran: 0
  });
  const [mootaDetails, setMootaDetails] = useState({
    bank_moota: "-", norek_moota: "-", nominal_moota: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const override = css`
        display: block;
        margin: 0 auto;
        border-color: #ea6123 solid 4px;
      `;

  useEffect(() => {
    fetchPaymentData();
    fetchUserData();
  }, []);

  const fetchPaymentData = async () => {
    try {
      const pathSegments = window.location.pathname.split('/');
      const generatedLink = pathSegments[pathSegments.length - 1];

      if (!generatedLink) {
        throw new Error('Link pembayaran tidak valid');
      }

      // Gunakan URL dengan segmen path
      const response = await axios.get(`${Constant.GET_PAYMENT_P}${generatedLink}`);

      // Validate the payment amount from response
      if (!response.data.nominal || response.data.nominal < MINIMUM_PAYMENT_AMOUNT) {
        throw new Error(`Nominal pembayaran tidak valid. Minimal pembayaran adalah ${formatRupiah(MINIMUM_PAYMENT_AMOUNT)}`);
      }

      setPaymentData({
        ...response.data,
        nominal: parseInt(response.data.nominal, 10) // Ensure nominal is an integer
      });
      setLoading(false);
    } catch (error) {
      setError(error.message || "Gagal memuat data pembayaran. Silakan coba lagi nanti.");
      setLoading(false);
      console.error("Error fetching payment data:", error);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Remove non-digits
    setPaymentState(prev => ({
      ...prev,
      nominal_pembayaran: parseInt(value) || 0
    }));
  };

  const formatRupiah = (nominal) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(nominal);
  };

  const handleVendorCallback = (callVendor, callMethod, callRekening) => {
    setPaymentState(prev => ({
      ...prev,
      selected_method: callMethod,
      selected_vendor: callVendor,
      no_rekening: callRekening,
    }));
  };

  const redirectToPage = (path) => {
    window.location.href = path;
  };

  const validatePayment = () => {
    if (!paymentState.selected_vendor) {
      alert("Harap pilih metode pembayaran");
      return false;
    }

    // Ensure nominal is a valid number and meets minimum requirement
    const amount = parseInt(paymentData.nominal, 10);

    return true;
  };

  const fetchUserData = async () => {
    if (cookies.get("user_id") != null) {
      try {
        const response = await axios.get(Constant.GET_USER, {
          headers: {
            Authorization: cookies.get("accessToken"),
          },
        });

        setUserData({
          user_id: response.data.id,
          full_name: response.data.name,
          phone_number: response.data.no_telp,
          email: response.data.email,
        });

        // Set form field properties
        const fullNameInput = document.getElementById("full_name");
        const emailInput = document.getElementById("email");
        const loginButton = document.getElementById("btn_for_login");

        if (fullNameInput) fullNameInput.readOnly = true;
        if (emailInput) emailInput.readOnly = true;
        if (loginButton) loginButton.hidden = true;

      } catch (error) {
        console.log("Error fetching user data:", error);
      }
    }
  };

  const handlePaymentSubmission = useCallback(async () => {
    if (!validatePayment()) return;

    const { selected_vendor } = paymentState;
    const parameter = {
      key_yayasan: Constant.KEY_YAYASAN,
      pendaftaran_id: paymentData.id,
      nominal: paymentState.nominal_pembayaran,
      vendor: selected_vendor.vendor,
      payment_type: selected_vendor.payment_type,
      payment_method: getPaymentMethod(selected_vendor),
      no_rekening: paymentState.no_rekening,
      user_id: userData.user_id,
      full_name: userData.full_name,
      phone_number: userData.phone_number,
      device: "PWA",
      email: userData.email
    };

    setIsSubmitting(true);
    setError(null);

    try {
      const response = await trackPromise(
        axios.post(
          Constant.POST_PAYMENT_P,
          parameter,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Basic ${btoa(MIDTRANS_CLIENT_KEY)}`,
            },
          }
        )
      );

      handlePaymentResponse(response.data);
    } catch (error) {
      console.error("Payment error:", error);
      const errorMessage = error.response?.data?.error ||
        "Gagal memproses pembayaran. Silakan coba lagi.";
      setError(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  }, [paymentState, paymentData]);

  const handlePaymentResponse = (responseData) => {
    if (responseData.snap_token) {
      window.snap.pay(responseData.snap_token, {
        onSuccess: () => redirectToPage("/notif/notif-wait"),
        onPending: () => redirectToPage("/notif/pending"),
        onError: () => {
          console.log("Pembayaran gagal");
          setPaymentState(prev => ({ ...prev, btn_pay: "Bayar Sekarang" }));
        },
        onClose: () => handlePaymentCancellation(responseData.snap_token),
      });
    } else if (responseData.moota) {
      setPaymentState(prev => ({ ...prev, btn_pay: "Saya sudah transfer" }));
      setMootaDetails({
        bank_moota: responseData.moota.nama_bank,
        norek_moota: responseData.moota.no_rekening,
        nominal_moota: responseData.moota.nominal,
      });
    }
  };

  const debouncedHandlePayment = debounce((e) => {
    e.preventDefault();
    if (!isSubmitting) {
      handlePaymentSubmission();
    }
  }, 300, { leading: true, trailing: false });

  const handlePayment = (e) => {
    e.preventDefault();
    debouncedHandlePayment(e);
  };


  const handlePaymentCancellation = async (snapToken) => {
    try {
      await axios.post(Constant.CANCEL_PAYMENT_P, {
        snap_token: snapToken,
        status: "cancelled"
      });
      console.log("Transaksi Dibatalkan");
      setPaymentState(prev => ({ ...prev, btn_pay: "Bayar Sekarang" }));
    } catch (error) {
      console.error("Error cancelling payment:", error);
    }
  };

  const getPaymentMethod = (vendor) => {
    if (vendor.payment_type === "virtual_account") {
      return vendor.midtrans_code;
    }
    if (vendor.payment_name === "Alfamart") {
      return vendor.payment_name.toUpperCase();
    }
    return vendor.payment_name;
  };

  const handleMootaClose = () => {
    setMootaDetails({
      bank_moota: "-",
      norek_moota: "-",
      nominal_moota: 0,
    });
    setPaymentState(prev => ({ ...prev, btn_pay: "Bayar Sekarang" }));
  };

  const handleGoBack = () => {
    if (paymentData.santri_id) {
      redirectToPage(`/santri/${paymentData.santri_id}`);
    } else {
      console.error("Santri ID is not available");
    }
  };

  if (error) return (
    <div className="page-content">
      <div className="error-message">{error}</div>
    </div>
  );

  const foto = paymentState.selected_vendor ? `/vendor/${paymentState.selected_vendor.id}` : "";

  return (
    <div className="page-content">
      <Header />
      <nav className="left header-kembali">
        <i
          id="ic-sidebar"
          className="fa fa-arrow-left"
          onClick={handleGoBack}
          style={{ margin: '10px' }}
        ></i>
        Pembayaran Pendaftaran
      </nav>
      {loading ? (
        <div className="loading-container">
          <ClipLoader css={override} size={150} color={"#ea6123"} loading={loading} />
        </div>
      ) : (
        <>
          <div className="rekap-card-detail">
            <div className="santri-info">
              <div className="info-row-2">
                <div className="info-tagihan">
                  <label className="info-label text-left">Santri:</label>
                  <p className="info-data text-left">{paymentData.santri_name}</p>
                </div>
              </div>
              <div className="info-row-2">
                <div className="info-tagihan">
                  <label className="info-label text-right">Tahun Ajaran:</label>
                  <p className="info-data text-right">{paymentData.tahun_ajaran}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="rekap-card-detail">
            <div className="santri-info">
              <div className="info-row">
                <div className="info-tagihan">
                  <label className="info-label">Total Tagihan:</label>
                  <p className="info-value">{formatRupiah(paymentData.nominal)}</p>
                </div>
                <div className="info-tagihan">
                  <label className="info-label">Sudah Dibayar:</label>
                  <p className="info-value">{formatRupiah(paymentData.sudah_dibayar)}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="content-boxed">
            <div className="payment-card">
              <label htmlFor="pembayaran_amount" className="label-input">
                Masukkan Nominal Pembayaran
              </label>
              <input
                type="text"
                id="pembayaran_amount"
                name="pembayaran_amount"
                className="input-nominal"
                value={formatRupiah(paymentState.nominal_pembayaran)}
                onChange={handleInputChange}
                placeholder="Masukkan nominal pembayaran"
                disabled={isSubmitting}
              />

              <MetodePembayaran
                callback={handleVendorCallback}
                disabled={isSubmitting}
              />

              <button
                className="btn-pay"
                onClick={handlePayment}
                disabled={
                  paymentState.nominal_pembayaran <= 0 ||
                  !paymentState.selected_method ||
                  isSubmitting
                }
              >
                <LoadingIndicator />
                {isSubmitting ? "Memproses..." : "Bayar Sekarang"}
              </button>
            </div>
          </div>


          {/* Modal for Bank Transfer */}
          <div
            id="moota_popup"
            className="modal"
            style={{ display: mootaDetails.nominal_moota > 0 ? 'block' : 'none' }}
          >
            <div className="modal-content">
              <span className="close" onClick={handleMootaClose}>&times;</span>

              <h2>Manual Bank Transfer</h2>
              {foto && <img src={foto} alt="bank" className="bank-logo" />}

              <div className="transfer-details">
                <div className="amount-section">
                  <h3>Total Pembayaran:</h3>
                  <div className="amount">{formatRupiah(mootaDetails.nominal_moota)}</div>
                </div>

                <div className="bank-section">
                  <h3>Transfer ke {mootaDetails.bank_moota}:</h3>
                  <div className="account-number">{mootaDetails.norek_moota}</div>
                </div>

                <div className="instructions">
                  <h3>Instruksi Pembayaran</h3>
                  <ol>
                    <li>Salin nomor rekening tujuan</li>
                    <li>Buka m-banking/e-banking/pergi ke ATM terdekat</li>
                    <li>Lakukan transfer ke bank tujuan {mootaDetails.bank_moota}</li>
                    <li>Masukkan nominal <strong>persis</strong> seperti yang tertera di atas!</li>
                    <li>Status pembayaran akan diperbarui dalam waktu maksimal 15 menit setelah transfer</li>
                  </ol>
                </div>

                <button
                  className="btn-confirm"
                  onClick={() => redirectToPage('/dashboard')}
                >
                  Selesaikan Pembayaran
                </button>
              </div>
            </div>
          </div>
        </>
      )};
    </div>
  );
};

export default Pendaftaran;